import adminApi from "./adminApi";

/* =========================
   ADMIN ORDER APIS
========================= */

// get all orders (ADMIN)
export const fetchOrders = async () => {
  const res = await adminApi.get("/admin/orders");
  return res.data;
};

// update order status (ADMIN)
export const updateOrderStatus = async (orderId, status) => {
  const res = await adminApi.put(
    `/admin/orders/${orderId}/status`,
    { status }
  );
  return res.data;
};

// delete order (ADMIN)
export const deleteOrder = async (orderId) => {
  const res = await adminApi.delete(`/admin/orders/${orderId}`);
  return res.data;
};
